import {
  Box,
  Button,
  Card,
  CardContent,
  Grid2 as Grid,
  IconButton,
  Tab,
  Tabs,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ButtonWithIcon } from "../../Common/Components/ButtonWithIcon";
import { theme } from "../../Common/SetupProfile/constant";
import axiosMain from "../../http/axiosMain";

/** Icons */
import { FaRegUserCircle } from "react-icons/fa";
import { GrContactInfo } from "react-icons/gr";
import { HiOutlineCurrencyRupee } from "react-icons/hi";
import { IoIosGitCompare } from "react-icons/io";
import { IoChevronBackOutline, IoLocationOutline } from "react-icons/io5";
import { LuMessageSquare } from "react-icons/lu";
import { TbCategory } from "react-icons/tb";
import { VscVerifiedFilled } from "react-icons/vsc";
import Facebook from "../../Assets/Img/facebook.png";
import Instagram from "../../Assets/Img/instagram.png";
import Snapchat from "../../Assets/Img/SnapChat.jpg";
import Youtube from "../../Assets/Img/youtube.png";
import { LabelWithIcon } from "../../Common/Components/LabelWithIcon";
import { ProfileSummary } from "./ProfileSummary";
import { InstagramStats } from "./InstagramStats/index";
import { YouTubeStats } from "./YouTubeStats";
import InfluencerCompareModal from "./InfluencerCompareModal";
import "../../Assets/css/influencer.css";

import contact from "../../Assets/Img/contact.svg";
import compare from "../../Assets/Img/compare.svg";
import message from "../../Assets/Img/message-icon.svg";
import favorite from "../../Assets/Img/favorite stast.svg";
import HeartDark from "../../Assets/Img/HeartDark.png";
import SubScriPtionMethod from "../../Brand/SubScriPtionMethod";
import { GlobalContext } from "../../../utils/GlobalContext";

export const InfluencerDetails = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const { userId } = useParams();
  const [influencerDetails, setInfluencerDetails] = useState("summary");
  const [loading, setLoading] = useState(true);
  const { userData } = useContext(GlobalContext);

  const [value, setValue] = useState("summary");

  const handleNavigateToSubscription = (subscriptionName) => {
    // console.log("clicked"); // ✅ should print
    localStorage.setItem("subscriptionName", subscriptionName);
    localStorage.removeItem("navigateBrandHome");
    navigate("/subscription"); // ✅ should navigate
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility

  const handleCompareClick = () => {
    setModalOpen(true); // Open the modal when "Compare" button is clicked
  };

  const handleCloseModal = () => {
    setModalOpen(false); // Close the modal
  };
  const fetchInfluencerDetails = async (userId) => {
    try {
      // Step 1: Get viewed count info
      const countRes = await axiosMain.get("/api/influencer/influencer-viewed-count");
      const subData = countRes?.data?.data?.[0];

      if (!subData) {
        console.error("Subscription data not found.");
        return;
      }

      const { viewed_influencer_ids, no_of_influencer_viewed, no_of_influencer_allowed } = subData;

      // Step 2: If already viewed, skip limit check
      const alreadyViewed = viewed_influencer_ids?.some(id => id.toString() === userId);

      if (!alreadyViewed && no_of_influencer_viewed === no_of_influencer_allowed) {
        navigate("/subscription");
        localStorage.setItem("navigateBrandHome", true);
        return;
      }

      // Step 3: Fetch influencer details
      const url = `/api/influencer/influencers/${userId}`;
      const response = await axiosMain.get(url);

      // Step 4: If not already viewed, update the view count
      if (!alreadyViewed) {
        await axiosMain.put("/api/influencer/influencer-viewed-count", {
          subscription_id: userData.subscription_id,
          influencers_id: userId
        });
      }

      // Step 5: Set influencer details
      if (response.data?.data?.user_id) {
        setInfluencerDetails(response.data.data);
      }

    } catch (err) {
      console.log("Error fetching influencer details:", err.message);
    } finally {
      setLoading(false);
    }

    // if (!k) {
    // try {
    //   console.log("kanjjjjjjjjjjj1111111111");
    //   // Step 1: Get viewed count info
    //   const countRes = await axiosMain.get("/api/influencer/influencer-viewed-count");
    //   const subData = countRes?.data?.data?.[0];

    //   // Step 2: Check view limit
    //   if (subData?.no_of_influencer_viewed === subData?.no_of_influencer_allowed) {
    //     navigate("/subscription");
    //     localStorage.setItem("navigateBrandHome", true);
    //     return;
    //   }

    //   let url = `/api/influencer/influencers/${userId}`;
    //   const response = await axiosMain.get(url);

    //   // Step 4: Update viewed count
    //   await axiosMain.put("/api/influencer/influencer-viewed-count", {
    //     subscription_id: userData.subscription_id,
    //     influencer_id: userId
    //   });

    //   if (response.data?.data?.user_id) {
    //     setInfluencerDetails(response.data.data);
    //   }
    // } catch (err) {
    //   console.log("Error fetching influencer details:", err.message);
    // } finally {
    //   setLoading(false);
    // }
    // } 
    // else {
    //   console.log("jjjjjjjjjjjjjjjj");

    //   navigate("/subscription");
    //   localStorage.setItem("navigateBrandHome", true);
    // }

  };

  useEffect(() => {
    if (userId) {
      fetchInfluencerDetails(userId);
    }
  }, [userId]);

  const getContentForTab = useMemo(() => {
    switch (value) {
      case "summary":
        return (
          <ProfileSummary
            details={influencerDetails}
            onPlatformClick={(platform) => {
              setValue(platform);
            }}
          />
        );
      case "instagram":
        return <InstagramStats details={influencerDetails} />;
      case "youtube":
        return <YouTubeStats details={influencerDetails} />;
      case "facebook":
        return <ProfileSummary />;
      case "snapchat":
        return <ProfileSummary />;
      default:
        return null;
    }
  }, [value, influencerDetails]);

  // if (loading) {
  //   return (
  //     <div
  //       className="content"
  //       style={{ padding: isSmallScreen ? "10px" : "20px" }}
  //     >
  //       <Typography>Loading...</Typography>
  //     </div>
  //   );
  // }

  return (
    <>
      <ThemeProvider theme={theme}>
        <Box>
          <Grid container rowSpacing={3}>
            <Grid size={12}>
              <Button
                variant="text"
                sx={{
                  padding: "4px 8px",
                  color: "#000",
                }}
                onClick={() => navigate(-1)}
              >
                <IoChevronBackOutline style={{ marginRight: "4px" }} />
                Back
              </Button>
            </Grid>
            <Box
              sx={{
                width: "100%",
                border: "1px solid rgba(238, 238, 238, 1)",
                borderRadius: "8px",
                p: 3,
              }}
            >
              <CardContent
                sx={{
                  padding: "16px !important",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {/* Left Section */}
                <Box display={"flex"}>
                  <Box display={"flex"} alignItems={"center"} gap={3}>
                    <Box width={"134px"} height={"134px"}>
                      <img
                        src={influencerDetails.profile}
                        style={{
                          objectFit: "cover",
                          borderRadius: "50%",
                          boxShadow: "1px 1px 15px 1px #00000033",
                          border: "2px solid #FFFFFF",
                        }}
                        alt=""
                        width={"134px"}
                        height={"134px"}
                      />
                    </Box>
                    <Box display={"flex"} flexDirection={"column"} gap={"4px"}>
                      <Box
                        display={"flex"}
                        alignItems={"end"}
                        columnGap={"6px"}
                      >
                        <Typography
                          color="primary"
                          sx={{
                            fontSize: "28px",
                            fontWeight: "500",
                          }}
                        >
                          {[
                            influencerDetails?.first_name,
                            influencerDetails?.last_name,
                          ]
                            .filter(Boolean)
                            .join(" ")}
                        </Typography>
                        <Box paddingBottom={"6px"}>
                          <VscVerifiedFilled color="#0066FF" />
                        </Box>
                      </Box>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        columnGap={"4px"}
                      >
                        <TbCategory color="#6b8e76" />
                        <Typography fontSize={"14px"} color="primary">
                          {influencerDetails?.category
                            ?.map((i) => i.name)
                            ?.filter(Boolean)
                            ?.join(", ") || "N/A"}
                        </Typography>
                      </Box>
                      <Box
                        display={"flex"}
                        alignItems={"center"}
                        columnGap={"4px"}
                      >
                        <IoLocationOutline color="#6b8e76" />
                        <Typography fontSize={"14px"} color="primary">
                          {[influencerDetails?.city, influencerDetails?.state]
                            .filter(Boolean)
                            ?.join(", ")}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Right Section */}
                <Box display={"flex"} justifyContent={"end"} gap={1}>
                  {influencerDetails?.source === "app" &&
                    (
                      <>
                        <IconButton
                          className="icons-influencer"
                          onClick={() => handleNavigateToSubscription("Message")}
                        >
                          <img src={message} alt="message" />
                        </IconButton>
                        <IconButton
                          className="icons-influencer"
                          onClick={() => handleNavigateToSubscription("Contact")}
                        >
                          <img src={contact} alt="contact" />
                        </IconButton>
                      </>
                    )
                  }
                  <IconButton
                    className="icons-influencer"
                    onClick={handleCompareClick}
                  >
                    <img src={compare} alt="compare" />
                  </IconButton>
                  <IconButton
                    className="icons-influencer"
                  // onClick={handleNavigateToSubscription}
                  >
                    <img
                      src={influencerDetails?.flag_favorite === true ? HeartDark : favorite}
                      alt="favorite"
                    />
                  </IconButton>
                </Box>
              </CardContent>
            </Box>
            <Grid size={12}>
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs value={value} onChange={handleChange}>
                    <Tab
                      label={
                        <LabelWithIcon
                          icon={FaRegUserCircle}
                          label={"Profile Summary"}
                        />
                      }
                      value={"summary"}
                    />
                    <Tab
                      label={
                        <LabelWithIcon img={Instagram} label={"Instagram"} />
                      }
                      value={"instagram"}
                    />
                    <Tab
                      label={<LabelWithIcon img={Youtube} label={"YouTube"} />}
                      value={"youtube"}
                    />
                    <Tab
                      label={
                        <LabelWithIcon img={Facebook} label={"Facebook"} />
                      }
                      value={"facebook"}
                    />
                    <Tab
                      label={
                        <LabelWithIcon img={Snapchat} label={"Snapchat"} />
                      }
                      value={"snapchat"}
                    />
                  </Tabs>
                </Box>
                <Box sx={{ paddingTop: "1rem" }}>{getContentForTab}</Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </ThemeProvider>
      <InfluencerCompareModal
        open={modalOpen}
        onClose={handleCloseModal}
        details={influencerDetails}
      />
    </>
  );
};
